import { server } from "@/api";

const adminPrefix = 'api/admin/subscriptions';

// ─── Current user ──────────────────────────────────────────────────────────
export const myStatus = async () => {
    return await server().get('api/subscription/status');
};

// ─── Admin management ────────────────────────────────────────────────────────
export const admin = {
    // Webhook settings
    getSettings: async () => {
        return await server().get(`${adminPrefix}/settings`);
    },
    updateSettings: async (data) => {
        return await server().post(`${adminPrefix}/settings`, data);
    },

    // Synced plans (product -> role + period)
    plans: async (params = {}) => {
        return await server().get(`${adminPrefix}/plans`, { params });
    },
    togglePlan: async (id) => {
        return await server().put(`${adminPrefix}/plans/${id}/toggle`);
    },
    deletePlan: async (id) => {
        return await server().delete(`${adminPrefix}/plans/${id}`);
    },

    // User subscriptions
    users: async (params = {}) => {
        return await server().get(`${adminPrefix}/users`, { params });
    },
    grant: async (data) => {
        return await server().post(`${adminPrefix}/users`, data);
    },
    extend: async (id, data) => {
        return await server().post(`${adminPrefix}/users/${id}/extend`, data);
    },
    revoke: async (id) => {
        return await server().post(`${adminPrefix}/users/${id}/revoke`);
    },
    resume: async (id) => {
        return await server().post(`${adminPrefix}/users/${id}/resume`);
    },

    // Webhook logs
    logs: async (params = {}) => {
        return await server().get(`${adminPrefix}/webhook-logs`, { params });
    },
    log: async (id) => {
        return await server().get(`${adminPrefix}/webhook-logs/${id}`);
    },
};

export default { myStatus, admin };
